<script lang="ts">
  import { getBorderColors, setFocus } from "../../helpers/helperMethods";
  interface Props {
    error?: boolean;
    value: number | string | undefined;
    max?: number | undefined;
    name?: any;
    id?: any;
    autoFocus?: boolean;
    required?: boolean;
    autoFocusDelay?: boolean;
    disabled?: boolean;
    class?: string;
    onChange?: (event: Event) => void;
    onInput?: (event: Event) => void;
    hasPressedContinue?: boolean;
    tabindex?: number;
    ariaDescribedby?: string;
  }

  let {
    error = false,
    value = $bindable(),
    max = undefined,
    name = undefined,
    id = undefined,
    autoFocus = false,
    required = true,
    autoFocusDelay = true,
    disabled = false,
    class: className,
    onChange,
    onInput,
    hasPressedContinue = false,
    tabindex = 0,
    ariaDescribedby = undefined,
  }: Props = $props();

  // Generate a unique ID if none provided
  const inputId = id || `number-input-${Math.random().toString(36).substr(2, 9)}`;

  const init = (el: any) => {
    if (autoFocus) {
      setFocus(el, autoFocusDelay);
    }
  };
</script>

<input
  type="number"
  use:init
  bind:value
  onchange={onChange}
  oninput={onInput}
  id={inputId}
  {disabled}
  {name}
  {tabindex}
  aria-invalid={error}
  aria-describedby={ariaDescribedby}
  class="text-M h-10 p-2 rounded-md relative appearance-none {disabled
    ? 'bg-Neutral200 cursor-not-allowed text-Neutral700'
    : ''} {getBorderColors(
    error,
    value === undefined && !hasPressedContinue,
    disabled
  )} {className}"
  {required}
  style={max !== undefined ? `max-width: ${max + 2}ch` : ""}
/>
